/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cc_ErrorInputs */

const en_cc_error = /** @type {(inputs: Cc_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The selection could not be transferred. Check your login and permissions; restart from the extension icon if needed.`)
};

const id_cc_error = /** @type {(inputs: Cc_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilihan tidak dapat diteruskan. Periksa login dan izin; mulai lagi melalui ikon ekstensi bila perlu.`)
};

/**
* | output |
* | --- |
* | "The selection could not be transferred. Check your login and permissions; restart from the extension icon if needed." |
*
* @param {Cc_ErrorInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_error = /** @type {((inputs?: Cc_ErrorInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_ErrorInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_error(inputs)
	return en_cc_error(inputs)
});